export class RoundEnd {
    constructor(
        public reason: string,
        public teamWonID: string | null,
        public ctEquipValue?: number | null,
        public tEquipValue?: number | null,
        public ctBuyType?: string | null,
        public tBuyType?: string | null,
        // Parsed from S32 on; null on older rounds and on uploaded demos.
        public tSideTeamID?: string | null
    ) { }
}
